import React from 'react';
import styles from './SubHeader.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const SubHeader = ({className, text}) => {
  return (
    <h1 className={`${cx('SubHeader')} ${className}`}>{text}</h1>
  );
};

export default SubHeader;